export default "__VITE_ASSET__DEyap9Qf__"